/**
 * 计算品牌条横向位移
 * @param {HTMLElement} section
 * @param {HTMLElement} track
 */
function updateBrandPresence(section, track) {
  if (window.innerWidth >= 1512) {
    track.style.transform = ''
    return
  }

  var sectionRect = section.getBoundingClientRect()
  var viewport = section.querySelector('.nelko-logo-rail')

  if (!viewport) {
    track.style.transform = ''
    return
  }

  var viewportHeight = window.innerHeight
  var maxShift = Math.max(track.scrollWidth - viewport.clientWidth, 0)

  if (!maxShift) {
    track.style.transform = ''
    return
  }

  // Start moving only after the section has fully entered the viewport and
  // finish when its top reaches the viewport top, keeping both endpoints visible.
  var travelRange = Math.max(viewportHeight - sectionRect.height, 1)
  var rawProgress = (viewportHeight - sectionRect.top - sectionRect.height) / travelRange
  var progress = Math.min(Math.max(rawProgress, 0), 1)
  track.style.transform = 'translate3d(' + String(maxShift * progress * -1) + 'px, 0, 0)'
}

/**
 * 初始化品牌条滚动联动
 */
function initNelkoBrandPresence() {
  var sections = document.querySelectorAll('[data-nelko-brand-presence]')

  if (!sections.length) {
    return
  }

  function handleUpdate() {
    sections.forEach(function updateSection(section) {
      var track = section.querySelector('[data-nelko-brand-track]')

      if (!track) {
        return
      }

      updateBrandPresence(section, track)
    })
  }

  handleUpdate()
  window.addEventListener('scroll', handleUpdate, { passive: true })
  window.addEventListener('resize', handleUpdate)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initNelkoBrandPresence)
} else {
  initNelkoBrandPresence()
}


(function() {
  const scrollBox = document.getElementById('ugc_scroll');
  let isDown = false; // 是否按下鼠标
  let startX, startY; // 鼠标按下时的位置
  let scrollLeft, scrollTop; // 容器初始滚动位置

  // 鼠标按下
  scrollBox.addEventListener('mousedown', (e) => {
    isDown = true;
    scrollBox.classList.add('active');
    startX = e.pageX - scrollBox.offsetLeft;
    startY = e.pageY - scrollBox.offsetTop;
    scrollLeft = scrollBox.scrollLeft;
    scrollTop = scrollBox.scrollTop;
    e.preventDefault(); // 防止选中文本
  });

  // 鼠标松开
  document.addEventListener('mouseup', () => {
    isDown = false;
  });

  // 鼠标移动
  document.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    const x = e.pageX - scrollBox.offsetLeft;
    const y = e.pageY - scrollBox.offsetTop;
    const walkX = x - startX; // 横向移动距离
    const walkY = y - startY; // 纵向移动距离
    scrollBox.scrollLeft = scrollLeft - walkX;
    scrollBox.scrollTop = scrollTop - walkY;
  });
})();
